<script>
import { mapState, mapMutations } from 'vuex'
import { checkLogin } from '@/api/digestCheck'
export default {
  name: 'CheckSign',
  data () {
    return {
      sign: null,
      payload: null,
      isIframe: window.isIframe
    }
  },
  computed: {
    ...mapState(['loginUri', 'wxLoginUri', 'findPwdByMobileUri', 'findPwdByWechatUri'])
  },
  methods: {
    ...mapMutations(['setLoginUri', 'setWxLoginUri', 'setFindPwdByMobileUri', 'setFindPwdByWechatUri'])
  },
  async created () {
    const query = this.$route.query
    const appId = query.appid
    const redirectUri = query.redirect_uri
    const digest = query.digest
    if (this.isIframe) {
      this.setLoginUri('/inner/login')
      this.setWxLoginUri('/inner/wx-login')
    } else {
      this.setLoginUri('/login')
      this.setWxLoginUri('/wx-login')
    }
    this.setFindPwdByMobileUri('/pwd/find-by-mobile')
    this.setFindPwdByWechatUri('/pwd/find-by-wechat')
    // 验签
    if (appId != null && redirectUri != null && digest != null) {
      this.sign = {
        appId,
        redirectUri,
        digest
      }
      const query = this.$route.query
      this.payload = query.payload
      this.sign = {
        appId: query.appid,
        redirectUri: query.redirect_uri,
        digest: query.digest
      }
      const noprofile = () => {
        this.$router.push({ name: 'Error404' })
      }
      await checkLogin(
        this.sign.appId,
        this.sign.redirectUri,
        this.sign.digest
      )
        .then(() => {
          const authParam = `appid=${this.sign.appId}&redirect_uri=${this.sign.redirectUri}&digest=${this.sign.digest}&payload=${encodeURIComponent(this.payload)}`
          // 设置登录地址
          if (this.isIframe) {
            this.setLoginUri(`/inner/login?${authParam}`)
            this.setWxLoginUri(`/inner/wx-login?${authParam}`)
          } else {
            this.setLoginUri(`/login?${authParam}`)
            this.setWxLoginUri(`/wx-login?${authParam}`)
          }
          this.setFindPwdByMobileUri(`/pwd/find-by-mobile?${authParam}`)
          this.setFindPwdByWechatUri(`/pwd/find-by-wechat?${authParam}`)
        })
        .catch(() => {
          noprofile()
        })
    }
  }
}
</script>
